import {
    Routes,
    Route,
} from "react-router-dom";
import AffiliateCreate from "./affiliate-create";

import AffiliatesPage from "./affiliates-page.component";


export default function AffiliatesRoutes() {
    return (
        <Routes>
            <Route path="/" element={<AffiliatesPage />} />
            <Route path="/create" element={<AffiliateCreate />} />

        </Routes>
    )
}